import React, { Component } from "react";
import { connect } from "react-redux";
import KeyboardReact from "react-simple-keyboard";
import { layouts } from "../../../constants/layouts";
import CustomEmail from "./customEmail";
import CustomGamer from "./customGamer";
import CustomName from "./customName";
import helmet from "../../../static/helmet.png";
import Progressbar from "../progressbar";
import "./custom.scss";
import Gdpr from "../gdpr";
import CustomEnd from "./customEnd";
const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedCustomRegister extends Component {
  emailForm = React.createRef();
  nameForm = React.createRef();

  state = {
    current: 0,
    email: "",
    name: "",
    inputName: "",
    layout: "default",
    teamId: null,
    keyboardVisible: true,
    timeOutId: null,
  };

  componentDidMount = () => {
    this.createNewTimeOut();
  };

  createNewTimeOut = () => {
    if (this.state.timeOutId !== null) {
      clearTimeout(this.state.timeOutId);
    }
    const timeOutId = setTimeout(() => {
      this.props.history.push("/");
    }, 120000);
    this.setState({ timeOutId: timeOutId });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  next = () => {
    this.setState({ current: this.state.current + 1, inputName: "" });
    this.createNewTimeOut();
  };

  prev = () => {
    this.setState({ current: this.state.current - 1, inputName: "" });
    this.createNewTimeOut();
  };

  setIds = (institutionId, categoryId) => {
    this.setState({ institutionId: institutionId, categoryId: categoryId });
  };

  setTeamId = (teamId) => {
    this.setState({ teamId: teamId });
  };

  onChangeAll = (inputs) => {
    if (this.state.inputName === "email") {
      this.emailForm.current.setFieldsValue({ email: inputs });
      this.setState({ email: inputs });
    } else if (this.state.inputName === "name") {
      this.nameForm.current.setFieldsValue({ name: inputs });
      this.setState({ name: inputs });
    }
  };

  setInputName = (event) => {
    this.setState({ inputName: event.target.id });
  };

  onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") {
      this.handleShift();
    }
  };

  handleShift = () => {
    const newLayoutName = this.state.layout === "default" ? "shift" : "default";
    this.setState({ layout: newLayoutName });
  };

  openKeyboard = () => {
    this.setState({ keyboardVisible: true });
  };

  closeKeyboard = () => {
    this.setState({ keyboardVisible: false });
  };

  render() {
    const steps = [
      {
        id: 0,
        title: "GDPR",
        description: "",
        ending: false,
        content: <Gdpr next={this.next} closeKeyboard={this.closeKeyboard} />,
      },
      {
        id: 1,
        title: "Hogyan szólíthatunk?",
        description: "A nyilvános ranglistán is ezen a néven jelensz meg!",
        ending: false,
        content: (
          <div>
            <CustomName
              formRef={this.nameForm}
              next={this.next}
              prev={this.prev}
              email={this.state.email}
              name={this.state.name}
              change={this.handleChange}
              history={this.props.history}
              setInputName={this.setInputName}
              openKeyboard={this.openKeyboard}
            />
          </div>
        ),
      },
      {
        id: 2,
        title: "Az emlékek küldéséhez kérjük add meg az email címedet!",
        description: "",
        ending: false,
        content: (
          <div>
            <CustomEmail
              formRef={this.emailForm}
              next={this.next}
              prev={this.prev}
              change={this.handleChange}
              email={this.state.email}
              setIds={this.setIds}
              setInputName={this.setInputName}
            />
          </div>
        ),
      },
      {
        id: 3,
        title: "Mutasd fel a kapott QR-kódot!",
        description:
          "Mostantól a QR kódod tárolja a megszerzett ezüstéréméket!",
        ending: false,
        content: (
          <div>
            <CustomGamer
              next={this.next}
              prev={this.prev}
              name={this.state.name}
              email={this.state.email}
              history={this.props.history}
              setInputName={this.setInputName}
              closeKeyboard={this.closeKeyboard}
            />
          </div>
        ),
      },
      {
        id: 4,
        title: "",
        description: "",
        ending: true,
        content: (
          <div>
            <CustomEnd
              history={this.props.history}
              closeKeyboard={this.closeKeyboard}
            />
          </div>
        ),
      },
    ];
    return (
      <div>
        {/* <div style={{ textAlign: "center" }}>
          <h2>Egyéni regisztráció</h2>
        </div> */}
        <div>
          <div
            style={{
              padding: "1.5em",
              display: "flex",
              justifyContent: steps[this.state.current].ending
                ? "flex-end"
                : "space-between",
            }}
          >
            {!steps[this.state.current].ending && (
              <div>
                <div style={{ display: "flex" }}>
                  <div>
                    <img
                      alt="helmet"
                      src={helmet}
                      style={{ height: "70", width: "86px" }}
                    />
                  </div>
                  <h1 className="custom-register-title">
                    {steps[this.state.current].title}
                  </h1>
                </div>
                <p className="custom-register-subtitle">
                  {steps[this.state.current].description}
                </p>
              </div>
            )}
            <div>
              <Progressbar
                steps={steps}
                current={this.state.current}
                history={this.props.history}
              />
            </div>
          </div>
          <div /* className="steps-content" */>
            {steps[this.state.current].content}
          </div>
          {this.state.keyboardVisible && (
            <div
              style={{
                position: "fixed",
                bottom: "0",
                width: "100%",
                /* height: "35vh", */
              }}
            >
              <KeyboardReact
                layout={layouts}
                layoutName={this.state.layout}
                onChange={(inputs) => this.onChangeAll(inputs)}
                keyboardRef={(r) => (this.keyboard = r)}
                inputName={this.state.inputName}
                onKeyPress={this.onKeyPress}
                //theme="dark-keyboard"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const CustomRegister = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedCustomRegister);
export default CustomRegister;
